module.exports = __webpack_public_path__ + "assets/img/Travel_001.cf228a51-ps.jpg";